/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatementTuitionDiscountLine
 */
export interface StatementTuitionDiscountLine {
    /**
     * 
     * @type {string}
     * @memberof StatementTuitionDiscountLine
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof StatementTuitionDiscountLine
     */
    amount?: number;
}

/**
 * Check if a given object implements the StatementTuitionDiscountLine interface.
 */
export function instanceOfStatementTuitionDiscountLine(value: object): value is StatementTuitionDiscountLine {
    return true;
}

export function StatementTuitionDiscountLineFromJSON(json: any): StatementTuitionDiscountLine {
    return StatementTuitionDiscountLineFromJSONTyped(json, false);
}

export function StatementTuitionDiscountLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatementTuitionDiscountLine {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function StatementTuitionDiscountLineToJSON(json: any): StatementTuitionDiscountLine {
    return StatementTuitionDiscountLineToJSONTyped(json, false);
}

export function StatementTuitionDiscountLineToJSONTyped(value?: StatementTuitionDiscountLine | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'amount': value['amount'],
    };
}

